export interface ProductCategory {
  id: number;
  name: string;
  slug: string;
}

export const productCategoryFromResponse = (
  responseData: any,
): ProductCategory => ({
  id: responseData.id,
  name: responseData.name,
  slug: responseData.slug,
});
